<template lang="pug">
.found-user__item(
  @click="handleClickAddUser"
)
  p.found-user__info.found-user__name(
    v-text="user.displayName"
  )
  p.found-user__info.found-user__email(
    v-text="user.email"
  )
  p.button__add-user ДОБАВИТЬ
</template>

<script>
import {
  ADD_USER_TO_APP,
} from '../constants';

export default {
  name: 'FoundUser',

  props: {
    user: {
      type: Object,
      required: true,
    },

    appName: {
      type: String,
      required: true,
    },

    clearSearchWord: {
      type: Function,
      required: true,
    },
  },

  methods: {
    handleClickAddUser() {
      this.clearSearchWord();
      this.$store.dispatch(ADD_USER_TO_APP, { user: this.user, appName: this.appName });
    },
  },
};
</script>

<style lang="scss" scoped>
  .found-user__item {
    display: flex;
    height: 48px;
    align-items: center;
    cursor: pointer;
    padding-left: 24px;
    padding-right: 24px;
    overflow: hidden;

    @include hover {
      background-color: black;

      .button__add-user {
        display: block;
      }

      .found-user__info {
        color: white;
      }
    }

    @include mobile {
      flex-direction: column;
      align-items: flex-start;
      padding-left: 0;
      padding-right: 0;
    }
  }

  .found-user__info {
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.31;
    letter-spacing: normal;
    color: #000000;
    width: 244px;

    @include mobile {
      font-size: 14px;
      line-height: 1.29;
    }
  }

  .found-user__email {
    margin-left: 15px;

    @include mobile {
      margin-left: 0;
    }
  }

  .button__add-user {
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: 1.25px;
    color: #ffffff;
    margin-left: auto;
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/FoundUser.vue